import React from 'react';
import {
    FormControl,
    Autocomplete,
    TextField
} from "@mui/material";

interface MuiSelectProps {
    label?: string;
    sKey: string;
    value: string;
    selectedValue?: any
    dataSource: any;
    mandatory?:boolean;
    isError?:boolean;
    errorText?:string;
    onChangeHandler?: any;
    disabled?:boolean
}


const DataMuiSelect: React.FC<MuiSelectProps> = ({label, value, selectedValue, dataSource, onChangeHandler,disabled,mandatory,isError,errorText}) => {

    const defaultProps = {
        options: dataSource,
        getOptionLabel: (option:any) => option[value]?option[value]:"",
    };
   // console.log(selectedValue);
    return (
        <FormControl fullWidth size="small" required={true}>
            <Autocomplete aria-required={true}
                          disablePortal
                          {...defaultProps}
                          id="combo-box-demo"
                          options={dataSource}
                          value={selectedValue?selectedValue:""}
                          onChange={(event, newValue) => {
                              onChangeHandler(newValue);
                              //setValue(newValue);
                          }}
                          onBlur={() => {isError=(mandatory && (!selectedValue || selectedValue.length===0)?true:false)}}
                          disabled={disabled}
                          renderInput={(params) => <TextField {...params} label={label} 
                          required={mandatory} 
                          error={isError && (!selectedValue || selectedValue.length===0)}
                          helperText={isError ? errorText: "" }/>}
            />
        </FormControl>

    )
}

export default DataMuiSelect;
